import React from 'react';
import NextError from 'next/error';

interface HttpError extends Error {
  statusCode: number;
  code: string;
}

const throwError = (
  statusCode: number,
  code: string,
): React.ReactElement => {
  if (typeof window !== 'undefined') {
    return <NextError statusCode={statusCode} />;
  }

  const ssrError = new Error(`${statusCode}`) as HttpError;
  ssrError.statusCode = statusCode;
  ssrError.code = code;
  throw ssrError;
};

export default throwError;
